import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-derm-sidebar',
  templateUrl: './derm-sidebar.component.html',
  styleUrls: ['./derm-sidebar.component.css']
})
export class DermSidebarComponent implements OnInit {

  @Input() provider;
  @Input() note;
  @Input() patient;
  @Input() readOnlyMode: any;
  constructor() { }

  ngOnInit(): void {
    console.log("Hello derm sidebar")
  }

}
